import { Injectable } from '@angular/core';
import {Router} from '@angular/router';
import {LocalStorageService,SessionStorageService} from 'ngx-webstorage';
import { CommonService } from './common.service';

@Injectable()
export class UserRolesService {

  userData: any
  constructor(private router:Router,
    private sessionStorageService:SessionStorageService,
    private localStorageService:LocalStorageService,
  private commonService: CommonService) {
}

  getUserRoles(){
    if(this.commonService.getUserInfo()){
      let userInfo = this.commonService.getUserInfo();
      return userInfo;
    }else{
      this.sessionStorageService.clear();
      this.localStorageService.clear();
      localStorage.clear();
      document.cookie = "_ctuid=; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
      this.router.navigate(['/auth/login']);
      return;
    }

    }
}





// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/common/user-roles.service.ts